export const Season = {
    Fall2024: '2024 Fall' as const,
    Spring2025: '2025 Spring' as const,
    Fall2025: '2025 Fall' as const,
    Spring2026: '2026 Spring' as const,
    Fall2026: '2026 Fall' as const,
}
export type Season = typeof Season[keyof typeof Season]

// Oldest to newest
export const ALL_SEASONS: Season[] = Object.values(Season);

// The season new matches and points are created in, and the default filter everywhere
export const CURRENT_SEASON: Season = Season.Fall2026;
